module.exports = __webpack_public_path__ + "media/images/placeholder-100x100-871a649c.png";